import { render, staticRenderFns } from "./CallTableActions.vue?vue&type=template&id=55112d66"
import script from "./CallTableActions.vue?vue&type=script&lang=js"
export * from "./CallTableActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports